// extracted by mini-css-extract-plugin
export default {"title":"Diagnostic_title__vT1zt","sendOrder":"Diagnostic_sendOrder__nRXjx","msg":"Diagnostic_msg__ZsP2y","pulse":"Diagnostic_pulse__7ofCJ"};